// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__VfBnL","iconWithCounter":"styles_iconWithCounter__bBKZp","counterForLabel":"styles_counterForLabel__Uqy4K","counterForIcon":"styles_counterForIcon__fo0kd"};